module.exports = __webpack_public_path__ + "img/Page_Flipping.76683a8a.svg";